import { FakDokumentView } from './fak-dokument-view';
import { Validators, FormGroup, FormControl, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseUpdateComponent, BaseDataService, QueryParameter, ModalService, ModelDataService, DropdownPicklistComponent, ConfirmationDialogButtons, DatePickerPopup2Component, UserRightsService, ErrorHandlerService, NotificationService } from 'yt-ng-framework';
import { Component, OnInit, ChangeDetectorRef, ViewChild, Output, EventEmitter } from "@angular/core";
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { FakDokument } from './fak-dokument';
import { List } from 'immutable';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { PodVrstaDokumentaStavkaView } from 'src/app/lookups/podvrste-dokumenta-stavka/podvrste-dokumenta-stavka-view';
import { KomitentView } from 'src/app/lookups/komitent/komitent-view';
// import { PoreskoOslobodjenje } from 'src/app/lookups/poresko-oslobodjenje/poresko-oslobodjenje';
import { Company } from 'src/app/admin/company/company';
import * as var_config from '../../var_config';
import { Input } from '@angular/core';
import { Valuta } from 'src/app/lookups/valuta/valuta';
import { error } from 'console';
import { HttpErrorResponse } from '@angular/common/http';
import { PoreskoOslobodjenje } from 'src/app/lookups/poresko-oslobodjenje/poresko-oslobodjenje';
import { of } from 'rxjs';
import { catchError, delay, map, retry, switchMap, tap } from 'rxjs/operators';
import { InstrukcijaZaPlacanjeByFirmaId } from 'src/app/fak/faktura/odabir/InstrukcijaZaPlacanjeByFirmaId';
// import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'yt-fak-dokument-update',
    templateUrl: './fak-dokument-update.component.html'
})
export class FakDokumentUpdateComponent extends BaseUpdateComponent<FakDokument> implements OnInit {

    parameterList: List<QueryParameter> = List([]);
    KomitentID: QueryParameter = new QueryParameter();
    podvrstaDokumentaGn : string = null;
    visibleNapomenaZaPdvOsl : boolean = false;
    VrstaDatumaPoreskeObavezeItems;
    pamtiVrednostJBKJS: string;
    parameterListZaKomitente: List<QueryParameter> = List([]);
    vrstaDatumaPoreskeObavezeParam: List<QueryParameter> = List([]);
    Domaca: QueryParameter = new QueryParameter();
    // ZaAvans: QueryParameter = new QueryParameter();
    ZaVrstuDatumaPoreskeObaveze: QueryParameter = new QueryParameter();
    hasUserRights: boolean; 
    varConfig=var_config;
    prevodDatumPlacanja: string = "FAKDOKUMENT.DATDPO.SINGULAR";
    valutaISOAlpha3Code: string = null;
    parameterListDatum: List<QueryParameter> = List([]);
    danParametar: QueryParameter = new QueryParameter();
    mesecParametar: QueryParameter = new QueryParameter();
    godinaParametar: QueryParameter = new QueryParameter();
    parametersForPodvrstaDokumentStavka: List<QueryParameter> = List([]);
    PodvrstaDokumentStavkaIDParameter: QueryParameter = new QueryParameter();

    // saveDisabled: boolean=false;
    constructor(
        protected activatedRoute: ActivatedRoute,
        protected baseDataService: BaseDataService,
        // protected notificationService: NotificationsService,
        protected toastrService: NotificationService,
        protected translateService: TranslateService,
        protected modalService: ModalService,
        protected router: Router,
        protected changeDetectorRef: ChangeDetectorRef,
        protected modelDataService: ModelDataService,
        protected userRightsService: UserRightsService,
        protected errorService: ErrorHandlerService
    ) {
        super(activatedRoute, baseDataService, toastrService, translateService, modalService, router)
    }

    @ViewChild('ddlKomitent', { static: true }) ddlKomitent: DropdownPicklistComponent<KomitentView>;
    @ViewChild('ddlPoreskoOslobodjenje', { static: true }) ddlPoreskoOslobodjenje: DropdownPicklistComponent<PoreskoOslobodjenje>;
    @ViewChild('dtpDatumDokumenta', { static: true }) dtpDatumDokumenta : DatePickerPopup2Component;
    @ViewChild('ddlPodvrstaDokumentaStavka', { static: true }) ddlPodvrstaDokumentaStavka: DropdownPicklistComponent<PodVrstaDokumentaStavkaView>;

    @Output() PrintDispatchEmitter = new EventEmitter();
    @Input() set SetPoljaZaVelikeLance(value){
        this.baseFormGroup.patchValue({ BrojNarudzbenice: value.BrojNarudzbenice });
        this.baseFormGroup.get('BrojNarudzbenice').updateValueAndValidity();
        this.baseFormGroup.patchValue({ DatumNarudzbenice: value.DatumNarudzbenice });
        this.baseFormGroup.get('DatumNarudzbenice').updateValueAndValidity();
        this.baseFormGroup.patchValue({ BrojPrijemnice: value.BrojPrijemnice });
        this.baseFormGroup.get('BrojPrijemnice').updateValueAndValidity();
        this.baseFormGroup.patchValue({ DatumPrijemnice: value.DatumPrijemnice });
        this.baseFormGroup.get('DatumPrijemnice').updateValueAndValidity();
        this.baseFormGroup.patchValue({ ReferencaKupcaNaDrugiDokument: value.ReferencaKupcaNaDrugiDokument });
        this.baseFormGroup.get('ReferencaKupcaNaDrugiDokument').updateValueAndValidity();
        // this.baseFormGroup.patchValue({ InterniBrojZaRutiranje: value.InterniBrojZaRutiranje });
        // this.baseFormGroup.get('InterniBrojZaRutiranje').updateValueAndValidity();
        this.baseFormGroup.patchValue({ OdgovornoLiceID: value.OdgovornoLiceID });
        this.baseFormGroup.get('OdgovornoLiceID').updateValueAndValidity();
    }
    @Input() set SetBagariteRobe(value){

            this.baseFormGroup.patchValue({ TezinaNeto: value.TezinaNeto});
            this.baseFormGroup.get('TezinaNeto').updateValueAndValidity();
            this.baseFormGroup.patchValue({ TezinaNetoJedinicaMereId: value.TezinaNetoJedinicaMereId});
            this.baseFormGroup.get('TezinaNetoJedinicaMereId').updateValueAndValidity();
            this.baseFormGroup.patchValue({ TezinaBruto: value.TezinaBruto});
            this.baseFormGroup.get('TezinaBruto').updateValueAndValidity();
            this.baseFormGroup.patchValue({ TezinaBrutoJedinicaMereId: value.TezinaBrutoJedinicaMereId});
            this.baseFormGroup.get('TezinaBrutoJedinicaMereId').updateValueAndValidity();
            this.baseFormGroup.patchValue({ Zapremina: value.Zapremina});
            this.baseFormGroup.get('Zapremina').updateValueAndValidity();
            this.baseFormGroup.patchValue({ ZapreminaJedinicaMereId: value.ZapreminaJedinicaMereId});
            this.baseFormGroup.get('ZapreminaJedinicaMereId').updateValueAndValidity();
            this.baseFormGroup.patchValue({ PakovanjeVrsta: value.PakovanjeVrsta});
            this.baseFormGroup.get('PakovanjeVrsta').updateValueAndValidity();
            this.baseFormGroup.patchValue({ PakovanjeKolicina: value.PakovanjeKolicina});
            this.baseFormGroup.get('PakovanjeKolicina').updateValueAndValidity();
            this.baseFormGroup.patchValue({ Pozicija: value.Pozicija });
            this.baseFormGroup.get('Pozicija').updateValueAndValidity();
            
            this.baseFormGroup.patchValue({ Crm: value.Crm });
            this.baseFormGroup.get('Crm').updateValueAndValidity();
            
            this.baseFormGroup.patchValue({ VozilaIds: value.VozilaIds });
            this.baseFormGroup.get('VozilaIds').updateValueAndValidity();
        
            this.baseFormGroup.patchValue({ Vozac: value.Vozac });
            this.baseFormGroup.get('Vozac').updateValueAndValidity();
            
            this.baseFormGroup.patchValue({ NapomenaTransporteri: value.NapomenaTransporteri });
            this.baseFormGroup.get('NapomenaTransporteri').updateValueAndValidity();

        }
    // @Input() set SetPoljaZaTransportere(value){
    //     this.baseFormGroup.patchValue({ Pozicija: value.Pozicija });
    //     this.baseFormGroup.get('Pozicija').updateValueAndValidity();
        
    //     this.baseFormGroup.patchValue({ Crm: value.Crm });
    //     this.baseFormGroup.get('Crm').updateValueAndValidity();
        
    //     this.baseFormGroup.patchValue({ VozilaIds: value.VozilaIds });
    //     this.baseFormGroup.get('VozilaIds').updateValueAndValidity();
       
    //     this.baseFormGroup.patchValue({ Vozac: value.Vozac });
    //     this.baseFormGroup.get('Vozac').updateValueAndValidity();
        
    //     this.baseFormGroup.patchValue({ NapomenaTransporteri: value.NapomenaTransporteri });
    //     this.baseFormGroup.get('NapomenaTransporteri').updateValueAndValidity();
    // }
    
    upozorenjeDatumOtpremnice = false;
    disabledInstrukcije = false;
    
    ngOnInit() {
        super.ngOnInit();
        // this.baseFormGroup.get('Napomena').disable();
        // this.baseFormGroup.get('Napomena').updateValueAndValidity();
        // this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);
        this.KomitentID.Name="KomitentID";
        this.KomitentID.Value=-1;
        this.parameterList = this.parameterList.push(this.KomitentID);
        this.hasUserRights = this.userRightsService.GetUserRightValue(this.modelData.MainList.UserRightsModelName,"canChangeDate")    
        
        this.ZaVrstuDatumaPoreskeObaveze.Name = "menuUrl";
        this.ZaVrstuDatumaPoreskeObaveze.Value = this.modelData["MainList"]["FormControlDataName"];
        this.vrstaDatumaPoreskeObavezeParam = this.vrstaDatumaPoreskeObavezeParam.push(this.ZaVrstuDatumaPoreskeObaveze);

        if (this.modelData["MainList"]["FormControlDataName"] == 'fak/avansni'){
            this.prevodDatumPlacanja = "FAKDOKUMENT.DATUMPRIJEMAAVANSA.SINGULAR";
            // this.ZaAvans.Name = "zaAvans";
            // this.ZaAvans.Value = "true";
            // this.vrstaDatumaPoreskeObavezeParam = this.vrstaDatumaPoreskeObavezeParam.push(this.ZaAvans);
        }else{
            // this.ZaAvans.Name = "zaAvans";
            // this.ZaAvans.Value = "false";
            // this.vrstaDatumaPoreskeObavezeParam = this.vrstaDatumaPoreskeObavezeParam.push(this.ZaAvans);
        }

        let dateNow = new Date();
        // let datum: NgbDate = new NgbDate(dateNow.getFullYear(), dateNow.getMonth()+1, dateNow.getDate())
        let datum: NgbDate = new NgbDate(dateNow.getFullYear(), dateNow.getMonth()+1, dateNow.getDate())
        this.forDatumParameter(datum);
      
        
        // this.Domaca.Name="Domaca";
        // this.Domaca.Value="true";
        // this.parameterListZaKomitente = this.parameterListZaKomitente.push(this.Domaca);

        this.addValidatorToFc('Broj', Validators.required, 'required', 'FAKDOKUMENT.BRDOK.VALIDATION.REQUIRED');
        this.addValidatorToFc('Broj', Validators.maxLength(20), 'maxlength', 'FAKDOKUMENT.BRDOK.VALIDATION.MAXLENGTH');
        this.addValidatorToFc('PodVrstaDokumentaStavkaID', Validators.required, 'required', 'FAKDOKUMENT.PODVRSTADOKUMENTASTAVKA.VALIDATION.REQUIRED');
        this.addValidatorToFc('Datum', Validators.required, 'required', 'FAKDOKUMENT.DATDOK.VALIDATION.REQUIRED');
        this.addValidatorToFc('KomitentID', Validators.required, 'required', 'FAKDOKUMENT.KOMITENT.VALIDATION.REQUIRED');
        this.addValidatorToFc('NacinPlacanjaID', Validators.required, 'required', 'FAKDOKUMENT.NACINPLACANJA.VALIDATION.REQUIRED');
        this.addValidatorToFc('Napomena', Validators.maxLength(500), 'maxlength', 'FAKDOKUMENT.NAPOMENA.VALIDATION.MAXLENGTH');
        this.addValidatorToFc('NapomenaZaPdvOsl', Validators.maxLength(2000), 'maxlength', 'FAKDOKUMENT.NAPOMENAZAPDVOSL.VALIDATION.MAXLENGTH');
        // this.addValidatorToFc('VrstaDatumaPoreskeObavezeID', Validators.required, 'required', 'FAKDOKUMENT.VRSTADATUMAPORESKEOBAVEZE.VALIDATION.REQUIRED');
        this.addValidatorToFc('BrojUgovora', Validators.maxLength(50), 'maxlength', 'FAKDOKUMENT.BROJUGOVORA.VALIDATION.MAXLENGTH');
        this.addValidatorToFc('BrojNarudzbenice', Validators.maxLength(50), 'maxlength', 'FAKDOKUMENT.BROJNARUDZBENICE.VALIDATION.MAXLENGTH');
        this.addValidatorToFc('MestoIsporukeRobe', Validators.maxLength(100), 'maxlength', 'FAKDOKUMENT.MESTOISPORUKEROBE.VALIDATION.MAXLENGTH');
        this.addValidatorToFc('MestoIzvrseneUsluge', Validators.maxLength(100), 'maxlength', 'FAKDOKUMENT.MESTOIZVRSENEUSLUGE.VALIDATION.MAXLENGTH');
        this.addValidatorToFc('PakovanjeVrsta', Validators.maxLength(30), 'maxlength', 'FAKDOKUMENT.PAKOVANJEVRSTA.VALIDATION.MAXLENGTH');
        this.addValidatorToFc('KontaktOsoba', Validators.maxLength(300), 'maxlength', 'FAKDOKUMENTIZVOZ.KONTAKTOSOBA.VALIDATION.MAXLENGTH');
        // this.addValidatorToFc('DatumPrometaDo', Validators.required, 'required', 'FAKDOKUMENT.DATUMPROMETADO.VALIDATION.REQUIRED');

        if (this.baseFormGroup.get('Kurs'))
            this.addValidatorToFc('Kurs', Validators.min(0.01), 'min', 'FAKDOKUMENTIZVOZ.KURS.VALIDATION.REQUIRED');
  
        // this.baseFormGroup.setValidators(checkDatumeSaDatumomDokumenta('DatDpo','DatumOtpremnice', 'RokVazenja', 'DatumPrometaOd', 'DatumPrometaDo', this));
        // this.baseFormGroup.setValidators(this.onDatumPrometaDo('DatumPrometaDo'));
        this.addValidatorToFc('BrojUgovora', checkIfCustomerJBKJS('BrojUgovora',this), 'checkControlBrojUgovora', 'FAKDOKUMENT.BROJUGOVORA.VALIDATION.REQUIRED');
        this.baseFormGroup.get('BrojUgovora').updateValueAndValidity();        

        this.baseFormGroup.setValidators([this.baseFormGroup.validator, checkDatumeSaDatumomDokumenta('DatDpo','DatumOtpremnice', 'RokVazenja', 'DatumPrometaOd', 'DatumPrometaDo', this)].filter(fn => typeof fn === 'function'));
        this.baseFormGroup.updateValueAndValidity();

        // const  currentValidators1 = this.baseFormGroup.validator ? this.baseFormGroup.validator : null;
        // this.baseFormGroup.setValidators([currentValidators1, checkDatumPrometa('DatumPrometaOd','DatumPrometaDo')]);
        this.baseFormGroup.setValidators([this.baseFormGroup.validator, checkDatumPrometa('DatumPrometaOd','DatumPrometaDo')].filter(fn => typeof fn === 'function'));
        this.baseFormGroup.updateValueAndValidity();

        // const currentValidators2 = this.baseFormGroup.validator ? this.baseFormGroup.validator : null;
        // this.baseFormGroup.setValidators([currentValidators2, checkDatumUgovoraInKZ('VrstaDatumaPoreskeObavezeID','DatumUgovora', this)]);
        this.baseFormGroup.setValidators([this.baseFormGroup.validator, checkDatumUgovoraInKZ('VrstaDatumaPoreskeObavezeID','DatumUgovora', this)].filter(fn => typeof fn === 'function'));
        this.baseFormGroup.updateValueAndValidity();

        // //zadržavanje postojećih sinhronih validatora
        // const currentValidators3 = this.baseFormGroup.validator ? this.baseFormGroup.validator : null;
        // this.baseFormGroup.setValidators(currentValidators3);

        // // Postavlja asinhroni validator. Angular automatski čeka rezultat Observable koji validator vraća i ažurira errors kada operacija završi.
        // this.baseFormGroup.setAsyncValidators([checkPoreskoOslobodjenje('Datum','PoreskoOslobodjenjeID', this)]);
        // this.baseFormGroup.updateValueAndValidity();

        // const currentValidators3 = this.baseFormGroup.validator ? this.baseFormGroup.validator : null;
        // this.baseFormGroup.setValidators([currentValidators3, checkPoreskoOslobodjenjeSinh('Datum','PoreskoOslobodjenjeID', this)]);
        this.baseFormGroup.setValidators([this.baseFormGroup.validator, checkPoreskoOslobodjenjeSinh('Datum','PoreskoOslobodjenjeID', this)].filter(fn => typeof fn === 'function'));
        this.baseFormGroup.updateValueAndValidity();

        this.baseFormGroup.setValidators([this.baseFormGroup.validator, checkDatumSmanjenjaKOSinh('DatumSmanjenja', this)].filter(fn => typeof fn === 'function'));
        this.baseFormGroup.updateValueAndValidity();
        
        this.IDProcessed
            .subscribe((value) => {                
                if (this.parameterListZaKomitente && this.parameterListZaKomitente.size == 0){
                    this.Domaca.Name="Domaca";
                    if (this.modelData.MainTitle == "izvozni računi")
                        this.Domaca.Value = "false";                
                    else 
                        this.Domaca.Value = "true";
                    this.parameterListZaKomitente = this.parameterListZaKomitente.push(this.Domaca);
                }
                
               
                // this.baseFormGroup.patchValue({ NacinPlacanjaID: 6 });
                // this.baseFormGroup.get('NacinPlacanjaID').updateValueAndValidity();
                
                if (value && this.Item.ID == -1) {                    
                    this.TransferParameters = List([]);
               
                    if(this.fcd["NacinPlacanjaID"] && this.fcd["NacinPlacanjaID"].IsVisible){
                        this.baseFormGroup.patchValue({ NacinPlacanjaID: 6 });
                        this.baseFormGroup.get('NacinPlacanjaID').updateValueAndValidity();
                    }

                    if (this.ddlPodvrstaDokumentaStavka && this.baseFormGroup.get('PodVrstaDokumentaStavkaID').value){
                        let odgovornoLiceId = this.ddlPodvrstaDokumentaStavka.Items.find(item => item.ID == this.baseFormGroup.get('PodVrstaDokumentaStavkaID').value).OdgovornoLiceID;
                        this.baseFormGroup.patchValue({ OdgovornoLiceID: odgovornoLiceId });
                        this.baseFormGroup.get('OdgovornoLiceID').updateValueAndValidity();
                    }

                    // let vrstaDatumaPoreskeObavezeID=this.VrstaDatumaPoreskeObavezeItems.find(obj => {
                    //     return obj.Sifra === -1
                    // }).ID
                    // this.baseFormGroup.patchValue({ VrstaDatumaPoreskeObavezeID: vrstaDatumaPoreskeObavezeID });
                    
                    // if (this.modelData.MainTitle == "avansni"){
                    //     let vrstaDatumaPoreskeObavezeID=this.VrstaDatumaPoreskeObavezeItems.find(obj => {
                    //           return obj.Sifra === 432
                    //       }).ID
                    //       this.baseFormGroup.patchValue({ VrstaDatumaPoreskeObavezeID: vrstaDatumaPoreskeObavezeID });
                    // }

                    let sifraPoreskeObaveze: number = null;
                    sifraPoreskeObaveze = this.modelData.MainTitle == "avansni" ? 432 : this.modelData.MainTitle == "knjizno-zaduzenje" ? 3 : null;
                     if (sifraPoreskeObaveze != null){
                        let vrstaDatumaPoreskeObavezeID=this.VrstaDatumaPoreskeObavezeItems.find(obj => {
                              return obj.Sifra === sifraPoreskeObaveze
                          }).ID
                          this.baseFormGroup.patchValue({ VrstaDatumaPoreskeObavezeID: vrstaDatumaPoreskeObavezeID });
                    }
                    

                    this.baseFormGroup.get('PodVrstaDokumentaStavkaID').enable();
                    this.baseFormGroup.get('PodVrstaDokumentaStavkaID').updateValueAndValidity();
                    this.baseFormGroup.get('Broj').enable();
                    this.baseFormGroup.get('Broj').updateValueAndValidity();
                    this.baseFormGroup.get('Datum').enable();
                    this.baseFormGroup.get('Datum').updateValueAndValidity();                    
                    let dateNow = new Date();
                    let date: NgbDate = new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate());
                    this.baseFormGroup.patchValue({ Datum: date });
                    this.baseFormGroup.get('Datum').updateValueAndValidity();
                    this.getBrojDokumenta();
                    this.KomitentID.Name="KomitentID";
                    if (this.baseFormGroup.get('KomitentID').value){
                        this.KomitentID.Value=this.baseFormGroup.get('KomitentID').value;
                    }
                    else
                        this.KomitentID.Value=-1;
                    this.parameterList = this.parameterList.push(this.KomitentID);
                    
                    if (dateNow){
                        let datum: NgbDate = new NgbDate(dateNow.getFullYear(), dateNow.getMonth()+1, dateNow.getDate())
                        this.forDatumParameter(datum);                      
                    }

                    //this.baseDataService.GetData()
                    //ako firma nije u sistemu PDVa i postoji samo jedna napomena o poreskom oslobođenju treba staviti po default-u tu napomenu u txtBox 
                    
                    // naziv kontrolera
                    // naziv metode iz kontrolera koju pozivam
                    // parametri koji se toj metodi prodleđuju
                    // naziv modela sa klijentske strane                    
                    
                    this.baseDataService.Get('firma','GetCompanyId',null,Company)
                        .subscribe((data:Company[])=>{
                            // // if (data && data["PdvUSistemu"] == false)                            
                            // // {
                            // //     this.baseDataService.Get('poreskooslobodjenje','get',null,PoreskoOslobodjenje)
                            // //     .subscribe((data:PoreskoOslobodjenje[])=>{
                            // //         if (data && data.length==1)
                            // //         {
                            // //             this.baseFormGroup.patchValue({NapomenaZaPdvOsl : data[0].Naziv});
                            // //         }
                            // //     })
                            // // }  
                            // if (data && data["PdvUSistemu"] == false){
                            //     this.translateService.get(['FAKDOKUMENT.NAPOMENAZAPDVOSL.TEXT'])
                            //     .subscribe(translate => {
                            //         this.baseFormGroup.patchValue({NapomenaZaPdvOsl : translate['FAKDOKUMENT.NAPOMENAZAPDVOSL.TEXT']});
                            //         this.baseFormGroup.get('NapomenaZaPdvOsl').updateValueAndValidity();
                            //         this.visibleNapomenaZaPdvOsl = true;                                   
                            //     });
                                
                            // }      
                             if (data && data["PoreskoOslobodjenjeID"] > 0){
                                this.baseFormGroup.patchValue({PoreskoOslobodjenjeID : data["PoreskoOslobodjenjeID"]});
                                    this.baseFormGroup.get('PoreskoOslobodjenjeID').updateValueAndValidity();                                
                            }              
                        })
                        this.dtpDatumDokumenta.ResetMinMaxDate();
                        this.TransferParameters = List([]);
                        this.baseInlineContainer.baseDetailListSum.Parameters=this.TransferParameters;
                        this.baseInlineContainer.baseDetailListSum.calculate();
                        this.enableControls();

                        this.parametersForPodvrstaDokumentStavka = List([]);
                        this.PodvrstaDokumentStavkaIDParameter.Name = "PodvrstaDokumentStavkaID";
                        this.PodvrstaDokumentStavkaIDParameter.Value = this.PodvrstaDokumentaItems.get(0)['ID'];
                        this.parametersForPodvrstaDokumentStavka = this.parametersForPodvrstaDokumentStavka.push(this.PodvrstaDokumentStavkaIDParameter);
                    }
                else{
                    this.disableControls();
                    let parameterList: List<QueryParameter> = List([new QueryParameter('Dokum', this.Item)]);
                    this.TransferParameters = this.TransferParameters.set(1, parameterList);
                    parameterList.clear();
                    if (this.baseFormGroup.get('Kurs')){
                        let parameterList: List<QueryParameter> = List([new QueryParameter('Kurs', this.baseFormGroup.get('Kurs').value)]);
                        this.TransferParameters = this.TransferParameters.set(2, parameterList);
                        parameterList.clear();
                        parameterList = List([new QueryParameter('ValutaISOAlpha3Code', this.valutaISOAlpha3Code)]); 
                        this.TransferParameters = this.TransferParameters.set(3, parameterList);
                        parameterList.clear();
                        
                    }
                    parameterList = List([new QueryParameter('Korekcija', this.baseFormGroup.get('KorekcijaVrednostiDokumenta').value)]); 
                    this.TransferParameters = this.TransferParameters.set(4, parameterList);
                    parameterList.clear();
                    
                    // parameterList = List([new QueryParameter('BrojDecimala', "4")]);
                    // this.TransferParameters = this.TransferParameters.set(5, parameterList);
                    // parameterList.clear();

                    this.baseInlineContainer.baseDetailListSum.Parameters=this.TransferParameters;
                    this.baseInlineContainer.baseDetailListSum.calculate();

                    // this.baseFormGroup.get('Datum').disable();
                    // this.baseFormGroup.get('Datum').updateValueAndValidity();     
                    
                    if(this.baseFormGroup.get('Datum').value != null && !this.hasUserRights){
                        let datum: NgbDate = this.baseFormGroup.get('Datum').value;
                        this.dtpDatumDokumenta.MinDate = new NgbDate(datum.year, datum.month, 1);
                        let maxDate = new Date(datum.year, datum.month, 1);
                        maxDate.setDate(maxDate.getDate() - 1);
                        //this.dtpDatumDokumenta.MaxDate = new NgbDate(datum.year, datum.month + 1, 1);
                        this.dtpDatumDokumenta.MaxDate = new NgbDate(maxDate.getFullYear(), maxDate.getMonth() + 1, maxDate.getDate());
                    }

                    if (this.baseFormGroup.get('Datum').value){
                        let datum: NgbDate = this.baseFormGroup.get('Datum').value;
                        this.forDatumParameter(datum);
                    }
                        // if(this.baseFormGroup.get('NapomenaZaPdvOsl').value != null && this.baseFormGroup.get('NapomenaZaPdvOsl').value != '')
                    //     this.visibleNapomenaZaPdvOsl = true;
                   
                    }
            })

        let _this = this;
        this.ItemSaved
            .subscribe((data: FakDokumentView) => {
                this.disableControls();
                this.baseDataService.GetByID(this.modelData.MainList.ModelName, data.ID, this.modelData.MainList.ModelClass)
                    .subscribe((fakDokument: FakDokument) => {
                        // if(this.Item['Broj'] && this.Item['Broj'] != fakDokument['Broj'] && this.Item['ID'] == fakDokument['ID']){
                        if(this.Item['Broj'] != fakDokument['Broj'] ){
                            // console.log('U ItemSaved u fak-dokument-update Item: ' + JSON.stringify(this.Item));
                            // console.log('U ItemSaved u fak-dokument-update fakDokument: ' + JSON.stringify(fakDokument));
                            // this.notificationsService.warn('Sačuvani dokument sadrži automatski korigovane podatke');   
                            this.translateService.get(['FAKDOKUMENT.BRDOK.CHANGETEXT', 'FAKDOKUMENT.BRDOK.CHANGEMESSAGE'])
                            .subscribe(translate => {
                                this.modalService.ShowConfirmationDialog(translate['FAKDOKUMENT.BRDOK.CHANGETEXT'],
                                    translate['FAKDOKUMENT.BRDOK.CHANGEMESSAGE'],'warning',ConfirmationDialogButtons.Ok)
                            });
                        }
                        _this.Item = fakDokument;
                        _this.baseFormGroup.patchValue(_this.Item);
                        _this.SavedItem = _this.baseFormGroup.getRawValue();  

                        this.TransferParameters = List([]);
                        let parameterList: List<QueryParameter> = List([new QueryParameter('Dokum', this.Item)]);
                        this.TransferParameters = this.TransferParameters.set(1, parameterList);
                        parameterList.clear();
                        if (this.baseFormGroup.get('Kurs')){
                            let parameterList: List<QueryParameter> = List([new QueryParameter('Kurs', this.baseFormGroup.get('Kurs').value)]);
                            this.TransferParameters = this.TransferParameters.set(2, parameterList);
                            parameterList.clear();
                            parameterList = List([new QueryParameter('ValutaISOAlpha3Code', this.valutaISOAlpha3Code)]); 
                            this.TransferParameters = this.TransferParameters.set(3, parameterList);
                            parameterList.clear();
                            
                        }
                        parameterList = List([new QueryParameter('Korekcija', this.baseFormGroup.get('KorekcijaVrednostiDokumenta').value)]); 
                        this.TransferParameters = this.TransferParameters.set(4, parameterList);
                        parameterList.clear();
                        
                        parameterList = List([new QueryParameter('BrojDecimala', this.brojDecimala)]);
                        this.TransferParameters = this.TransferParameters.set(5, parameterList);
                        parameterList.clear();

                        this.baseInlineContainer.baseDetailListSum.Parameters=this.TransferParameters;
                        this.baseInlineContainer.baseDetailListSum.calculate();

                        
                        
                    })
                   
            })           

    }

    // ngAfterViewInit(){
    //     if (this.Item.ID == -1 && this.ddlPodvrstaDokumentaStavka){

    //     }
    // }


    PodvrstaDokumentaItems;
    PodvrstaDokumentaGetItems(items){
        this.PodvrstaDokumentaItems = items;
    }

    forDatumParameter(datum: NgbDate){
        this.danParametar.Name = "day";
        this.danParametar.Value = datum.day;
        this.mesecParametar.Name = "month";
        this.mesecParametar.Value = datum.month;
        this.godinaParametar.Name = "year";
        this.godinaParametar.Value = datum.year;
        this.parameterListDatum = List([]);
        this.parameterListDatum = this.parameterListDatum.push(this.danParametar);
        this.parameterListDatum = this.parameterListDatum.push(this.mesecParametar);
        this.parameterListDatum = this.parameterListDatum.push(this.godinaParametar);   
    }

    disableControls(){
        this.baseFormGroup.get('PodVrstaDokumentaStavkaID').disable();
        this.baseFormGroup.get('PodVrstaDokumentaStavkaID').updateValueAndValidity();
        this.baseFormGroup.get('Broj').disable();
        this.baseFormGroup.get('Broj').updateValueAndValidity();
        this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);
        // if (this.router.url == "/fak/racuni"){
        //     this.baseFormGroup.get('Datum').disable();
        //     this.baseFormGroup.get('Datum').updateValueAndValidity();
        // }
    }

    enableControls(){
        // this.baseFormGroup.get('PodVrstaDokumentaStavkaID').enable();
        // this.baseFormGroup.get('PodVrstaDokumentaStavkaID').updateValueAndValidity();
        // this.baseFormGroup.get('Broj').enable();
        // this.baseFormGroup.get('Broj').updateValueAndValidity();
        this.baseFormGroup.enable();
        this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);
    
    }

    // brojDecimala : string = "";
    brojDecimala : number = 0;

    onPodVrstaSelect(value: PodVrstaDokumentaStavkaView) {
        if (value !=null){
            if (this.Item.ID==-1)
                this.getBrojDokumenta();
            if(!this.modelData.MainList.LoadFormControlDataOnInit)
                this.getFormControlData('fak/racun', this.fc.PodVrstaDokumentaStavkaID.value);
            if (this.Item.ID == -1 && value.OdgovornoLiceID != null){
                this.baseFormGroup.patchValue({OdgovornoLiceID:value.OdgovornoLiceID});
                this.baseFormGroup.get('OdgovornoLiceID').updateValueAndValidity();                
            }
            this.podvrstaDokumentaGn = value.PodvrstaDokumentaGn;

            let parameterList: List<QueryParameter> = List([new QueryParameter('Dokum', this.Item)]);
            parameterList.clear();   
            this.brojDecimala = value.BrojDecimala;        
            parameterList = List([new QueryParameter('BrojDecimala', value.BrojDecimala)]);
            this.TransferParameters = this.TransferParameters.set(5, parameterList);
            parameterList.clear();
            //format za Cenu
            if (this.baseInlineContainer.baseDetailList["_parentPropertyValue"] &&
                this.baseInlineContainer.baseDetailList._model.TableColumns[3].Format != "1."+this.brojDecimala+"-"+this.brojDecimala
            ){
                this.baseInlineContainer.baseDetailList._model.TableColumns[3].Format = "1."+this.brojDecimala+"-"+this.brojDecimala;
                this.baseInlineContainer.baseDetailList.RefreshData();
            }
        }
    }

    getBrojDokumenta() {
        let podvrstaid = this.baseFormGroup.get('PodVrstaDokumentaStavkaID').value;
        let datum = this.baseFormGroup.get('Datum').value;
        let _this = this;
        
        if (this.Item.ID == -1 && podvrstaid && datum){
            this.baseDataService.GetData('FakDokument', 'KreirajBrojDokumenta', { 'PodVrstaDokumentaStavkaID': podvrstaid, 'Datum': datum })
                .subscribe(data => {                   
                    if (_this.baseFormGroup.get('Datum').value){
                        this.baseFormGroup.patchValue({ Broj: data });
                        this.baseFormGroup.get('Broj').updateValueAndValidity();
                    }
              
                },
            error =>{
                if(error instanceof HttpErrorResponse){
                    let _message;             
                    _message = this.errorService.getServerMessage(error);
                   
                    this.translateService.get(_message)
                    .subscribe(translate => {
                      this.modalService.ShowConfirmationDialog("Problemi kod preuzimanja", translate, "warning", ConfirmationDialogButtons.Ok);
                      this.ResetValues(true,false);
                    });
                  }
            }
        )

            if(this.fcd["NacinPlacanjaID"].IsVisible == false){
                this.baseFormGroup.patchValue({ NacinPlacanjaID: 32 });
                this.baseFormGroup.get('NacinPlacanjaID').updateValueAndValidity();
            }
        }
    }

    editMode: boolean = false;
    AddDocument() { 
        let a: number;
        a=0;
    }
    //Print(ID1) { }
    item: any;
    PrintKnj(item1) { }
    SaveMaster(qq) { }
    onDatumChange(value) {        
        if (value != null) {
            if (this.Item.ID>0 && this.router.url == "/fak/racuni") {
                if (this.SavedItem != null
                 && this.SavedItem["Datum"] != null
                 && this.SavedItem["Datum"]["month"]!=value.month
                 && this.SavedItem["Datum"]!=value && this.baseFormGroup.get("Datum").value != value
                 && !this.hasUserRights){
                    this.translateService.get('FAKDOKUMENT.DATUM.VANMESECA.WARNING')
                    .subscribe(translate => {
                        alert(translate);
                    });
                    setTimeout(() => {
                    this.baseFormGroup.patchValue({Datum: this.SavedItem["Datum"]});
                    this.baseFormGroup.get('Datum').updateValueAndValidity();
                    this.changeDetectorRef.markForCheck();
                    }, 0);                    
                 }
                 this.onDaniChange(this.baseFormGroup.get('Dani').value);
                 this.onDaniVazenjaChange(this.baseFormGroup.get('DaniVazenja').value);        
            } else {
                this.getBrojDokumenta();
                this.onDaniChange(this.baseFormGroup.get('Dani').value);
                this.onDaniVazenjaChange(this.baseFormGroup.get('DaniVazenja').value);

            }
            let parameterList: List<QueryParameter> = List([new QueryParameter('Datum', value)]);
            this.TransferParameters = this.TransferParameters.set(0, parameterList);
            this.forDatumParameter(value);         
            
        }
    }

    pamtiVrednostKomitentObjekatID: number;
    
    onKomitentSelect(value){
        if (value){
            if(this.pamtiVrednostKomitentObjekatID && this.pamtiVrednostKomitentObjekatID!=value.ID){
                this.baseFormGroup.patchValue({KomitentObjekatID:null});
                this.baseFormGroup.get('KomitentObjekatID').updateValueAndValidity();
                // this.pamtiVrednostJBKJS = value["Jbkjs"];
            }
        
          this.pamtiVrednostJBKJS = value["Jbkjs"];
          this.pamtiVrednostJBKJS = this.pamtiVrednostJBKJS != null ? this.pamtiVrednostJBKJS.trim() : null;
          this.parameterList=List([]);
          this.KomitentID.Name="KomitentID";
          this.KomitentID.Value=value.ID;
          this.parameterList = this.parameterList.push(this.KomitentID);
          //this.TransferParameters = this.TransferParameters.set(0, this.parameterList);
          this.pamtiVrednostKomitentObjekatID=value.ID;
        
          this.baseFormGroup.patchValue({ZaCrf: value["ZaCrf"]})
          
          this.baseFormGroup.get('BrojUgovora').clearValidators();
          this.baseFormGroup.get('BrojUgovora').updateValueAndValidity();
          this.addValidatorToFc('BrojUgovora', checkIfCustomerJBKJS('BrojUgovora',this), 'checkControlBrojUgovora', 'FAKDOKUMENT.BROJUGOVORA.VALIDATION.REQUIRED');
          this.baseFormGroup.get('BrojUgovora').updateValueAndValidity();
        
          //za RC14
          if(this.baseFormGroup.get('Datum').value != null && this.Item.ID == -1)
          {
            let datumRacuna: NgbDate = this.baseFormGroup.get('Datum').value;
            let parameters = {'KomitentID' : value.ID, 'Datum' : datumRacuna};

            this.baseDataService.Post('KomitentUgovor','GetUgovorByKomitentIdAndDatum', parameters, null)
            .subscribe(brojUgovora2 => {
                this.baseFormGroup.patchValue({BrojUgovora: brojUgovora2})
                this.baseFormGroup.get('BrojUgovora').updateValueAndValidity();              
            
            });       
        }      
        }
      }

      onDaniChange(value){
        let dani = value;
        let datum= this.baseFormGroup.get('Datum').value;
        if (datum)
        {
            let _izracunajdatum:Date = new Date(datum["year"], datum["month"]-1, datum["day"]);

            _izracunajdatum.setDate(_izracunajdatum.getDate()+dani);

            let rok_datum:NgbDate = new NgbDate(_izracunajdatum.getFullYear(),_izracunajdatum.getMonth()+1, _izracunajdatum.getDate());

            if (this.baseFormGroup.get('DatDpo').value){
                let datdpo:Date = new Date(this.baseFormGroup.get('DatDpo').value["year"], this.baseFormGroup.get('DatDpo').value["month"]-1, this.baseFormGroup.get('DatDpo').value["day"]);
                // if(_izracunajdatum.getDate() != datdpo.getDate()){
                if(_izracunajdatum.toDateString() != datdpo.toDateString()){
                    this.baseFormGroup.patchValue({DatDpo:rok_datum});
                    this.baseFormGroup.get('DatDpo').updateValueAndValidity();
                }
            }
            else{
                this.baseFormGroup.patchValue({DatDpo:rok_datum});
                this.baseFormGroup.get('DatDpo').updateValueAndValidity();
            }
        }
      }

      onDaniVazenjaChange(value){
        let dani = value;
        let datum= this.baseFormGroup.get('Datum').value;
        if (datum)
        {
            let _izracunajdatum:Date = new Date(datum["year"], datum["month"]-1, datum["day"]);

            _izracunajdatum.setDate(_izracunajdatum.getDate()+dani);

            let rok_datum:NgbDate = new NgbDate(_izracunajdatum.getFullYear(),_izracunajdatum.getMonth()+1, _izracunajdatum.getDate());

            if (this.baseFormGroup.get('RokVazenja').value){
                let rokvazenja:Date = new Date(this.baseFormGroup.get('RokVazenja').value["year"], this.baseFormGroup.get('RokVazenja').value["month"]-1, this.baseFormGroup.get('RokVazenja').value["day"]);
                if(_izracunajdatum.toISOString() != rokvazenja.toISOString()){
                    this.baseFormGroup.patchValue({RokVazenja:rok_datum});
                    this.baseFormGroup.get('RokVazenja').updateValueAndValidity();
                }
            }
            else{
                this.baseFormGroup.patchValue({RokVazenja:rok_datum});
                this.baseFormGroup.get('RokVazenja').updateValueAndValidity();
            }
        }
      }

      onDatDpoChange(value) {
        if (value) {
            let datdpo:Date = new Date(value["year"], value["month"]-1, value["day"]);
            let _datum =  this.baseFormGroup.get('Datum').value;
            let datum:Date = new Date(_datum["year"], _datum["month"]-1, _datum["day"]);

            let dani:Number = Number(((datdpo.valueOf()-datum.valueOf())/(1000*60*60*24)).toFixed(0));
            if (dani != Number(this.baseFormGroup.get('Dani').value))
            {
                this.baseFormGroup.patchValue({Dani:dani});
                this.baseFormGroup.get('Dani').updateValueAndValidity();
            }


        }
    }

    onRokVazenjaChange(value) {
        if (value) {
            let rokvazenja:Date = new Date(value["year"], value["month"]-1, value["day"]);
            let _datum =  this.baseFormGroup.get('Datum').value;
            let datum:Date = new Date(_datum["year"], _datum["month"]-1, _datum["day"]);

            let dani:Number = Number(((rokvazenja.valueOf()-datum.valueOf())/(1000*60*60*24)).toFixed(0));
            if (dani != Number(this.baseFormGroup.get('DaniVazenja').value))
            {
                this.baseFormGroup.patchValue({DaniVazenja:dani});
                this.baseFormGroup.get('DaniVazenja').updateValueAndValidity();
            }
        }
    }
   
  


    // DodajPoreskoOslobodjenje (){
    //     let _modelData = this.modelDataService.GetModelDataByPath("spisak-poreskih-oslobodjenja");
    //     if (_modelData){
    //         this.modalService.ShowModal(0,_modelData,null,true,null)            
    //         .result
    //         .then((item)=>{                 
    //             //u ovom momentu se pokrene maska za odabir Poreskog oslobođenja               
    //             if(item){
    //                 this.baseFormGroup.patchValue({NapomenaZaPdvOsl : item});
    //                 this.baseFormGroup.get("NapomenaZaPdvOsl").updateValueAndValidity();  
    //             }             
                    
                                      
                
    //         },(reason) => {

    //         })         
     
    //     }
    // }
      

      onDatumPrometaOdChange(value) {
        if (value) {
            if (this.baseFormGroup.get("DatumPrometaDo").value == null)
            {
                this.baseFormGroup.patchValue({DatumPrometaDo: value});
                this.baseFormGroup.get("DatumPrometaDo").updateValueAndValidity();
            }           

        }
    }

    onDatumOtpremniceChange(value){
        if (value){
            let datumOd = this.baseFormGroup.get("DatumPrometaOd").value;
            let datumDo = this.baseFormGroup.get("DatumPrometaDo").value;
            if (datumOd && datumDo){
                let _datumOtpremnice:Date = new Date(value["year"], value["month"]-1, value["day"]);
                let _datumOd:Date = new Date(datumOd["year"], datumOd["month"]-1, datumOd["day"]);
                let _datumDo:Date = new Date(datumDo["year"], datumDo["month"]-1, datumDo["day"]);
                if (!(_datumOtpremnice.getTime() >= _datumOd.getTime() &&
                    _datumOtpremnice.getTime() <= _datumDo.getTime())){}

            }

        }
    }

    CheckDatumOtpremnice(datumOtpremniceKey: string, datumPrometaOdKey: string, datumPrometaDoKey: string){
        return (group: FormGroup): {[key : string]: any} =>{
            let datumOtpremnice = group.controls[datumOtpremniceKey].value;
            let datumOd = group.controls[datumPrometaOdKey].value;
            let datumDo = group.controls[datumPrometaDoKey].value;
            if (datumOtpremnice && datumOd && datumDo){
                let _datumOtpremnice:Date = new Date(datumOtpremnice["year"], datumOtpremnice["month"]-1, datumOtpremnice["day"]);
                let _datumOd:Date = new Date(datumOd["year"], datumOd["month"]-1, datumOd["day"]);
                let _datumDo:Date = new Date(datumDo["year"], datumDo["month"]-1, datumDo["day"]);
                if (!(_datumOtpremnice.getTime() >= _datumOd.getTime() &&
                    _datumOtpremnice.getTime() <= _datumDo.getTime())){
                        return { checkControls :{valid:true, message: 'FAKDOKUMENT.DATUMOTPREMNICEOPSEGPROMET.VALIDATION.WARNING'}};
                }
                // else
                //     return { checkControls :{valid:true, message:'ok'}};
            }
            // else
            //     return { checkControls :{valid:true, message:'ok'}};
        }
    }

    VrstaDatumaPoreskeObavezeGetItems(items)
    {
        this.VrstaDatumaPoreskeObavezeItems=items;
    }

    PoreskaOslobodjenjaItems;
    PoreskaOslobodjenjaGetItems(items){
        this.PoreskaOslobodjenjaItems = items;
    }

    onKursChange(value){
        let parameterList: List<QueryParameter> = List([new QueryParameter('Kurs', value)]);
        this.TransferParameters = this.TransferParameters.set(2, parameterList);
        this.baseInlineContainer.baseDetailListSum.Parameters=this.TransferParameters;
        this.baseInlineContainer.baseDetailListSum.calculate();
        parameterList.clear();
    }

    onValutaSelected(value: Valuta){
        if (value){
            this.valutaISOAlpha3Code = value.ISOAlpha3Code;
            let parameterList: List<QueryParameter> = List([new QueryParameter('ValutaISOAlpha3Code', this.valutaISOAlpha3Code)]);
            this.TransferParameters = this.TransferParameters.set(3, parameterList);
            this.baseInlineContainer.baseDetailListSum.Parameters=this.TransferParameters;
            this.baseInlineContainer.baseDetailListSum.calculate();
            parameterList.clear();
        }
        
    }

    onKorekcijaSelect(){
        //if (this.baseFormGroup.get('KorekcijaVrednostiDokumenta')){        
        //    let parameterList = List([new QueryParameter('Korekcija', this.baseFormGroup.get('KorekcijaVrednostiDokumenta').value)]); 
        //    this.TransferParameters = this.TransferParameters.set(4, parameterList);
        //    parameterList.clear();
        //    this.baseInlineContainer.baseDetailListSum.Parameters=this.TransferParameters;
        //    this.baseInlineContainer.baseDetailListSum.calculate();
        //}
    }

    onRestoreClick(): void {
        this.Reset(true).subscribe((result) => {
            if (result) {
                //console.log('Restore successfully executed');
            } else {
                //console.log('Restore was cancelled by the user');
            }
        });
    }

    GetInstrukcije(){
        // this.disabledInstrukcije = true;
        this.baseDataService.Get('FakDokumentIzvoz','GetInstrukcijeByFirmaID',null,InstrukcijaZaPlacanjeByFirmaId)
        .subscribe((data:InstrukcijaZaPlacanjeByFirmaId[])=>{
            if (data && data.length == 0){
                this.translateService.get(['FAKDOKUMENT.INSTRUKCIJAZAPLACANJE.SINGULAR','FAKDOKUMENT.INSTRUKCIJAZAPLACANJE.EMPTY'])
                .subscribe(translate =>{
                    this.modalService.ShowConfirmationDialog(translate['FAKDOKUMENT.INSTRUKCIJAZAPLACANJE.SINGULAR'],translate['FAKDOKUMENT.INSTRUKCIJAZAPLACANJE.EMPTY'],"info",ConfirmationDialogButtons.Ok)
                    return false;
                })
                
            }
            let _modelData = this.modelDataService.GetModelDataByPath("instrukcije-za-placanje");
            let itemsParameter = new QueryParameter("items", data);
            if (_modelData) {
                this.modalService
                  .ShowModal(0, _modelData, null, true, [itemsParameter])
                  .result.then(
                    (opis) => {
                        if (opis){
                            this.baseFormGroup.get('InstrukcijaZaPlacanje').setValue(opis);
                            this.baseFormGroup.get('InstrukcijaZaPlacanje').updateValueAndValidity();
                        }
                        
                    },
                    (reason) => {}
                  );
              }

        })
    }

    GetInfo(){
        // let _modelData = this.modelDataService.GetModelDataByPath("instrukcije-za-placanje");
        let info_tekst = "Unos instrukcija za plaćanje se nalazi u meniju: " + "\n\nPočetna -> Admin -> Firme (kartica Tekući računi)";
        // info_tekst = info_tekst.replace(/\n/g, '<br>');
        
        this.translateService.get(['FAKDOKUMENT.INSTRUKCIJAZAPLACANJE.INFO.SINGULAR', 'FAKDOKUMENT.INSTRUKCIJAZAPLACANJE.INFO.TEXT'])
                            .subscribe(translate => {
                                // let info_tekst = "Unos instrukcija za plaćanje se nalaze na: " + translate[_modelData.BreadcrumbLabel] + ", kartica tekući računi";
                                this.modalService.ShowConfirmationDialog(translate['FAKDOKUMENT.INSTRUKCIJAZAPLACANJE.INFO.SINGULAR'],
                                    translate['FAKDOKUMENT.INSTRUKCIJAZAPLACANJE.INFO.TEXT'],'info',ConfirmationDialogButtons.Ok)
                            });
    }

       

}


    function checkDatumeSaDatumomDokumenta(datDpoIDKey: string, datumOtpremniceIDKey: string, rokVazenjaIDKey: string, datumPrometaOdKey: string, datumPrometaDoKey: string, mainThis: any){
        return (group: FormGroup): {[key : string]: any} =>{
            let datDpo = group.controls[datDpoIDKey].value;
            let _datDpo : Date = datDpo != null ? new Date(datDpo["year"], datDpo["month"]-1, datDpo["day"]) : null;
            let datumOtpremnice = group.controls[datumOtpremniceIDKey].value;
            let _datumOtpremnice : Date = datumOtpremnice != null ? new Date(datumOtpremnice["year"], datumOtpremnice["month"]-1, datumOtpremnice["day"]) : null;
            let rokVazenja = group.controls[rokVazenjaIDKey].value;
            let _rokVazenja : Date = rokVazenja != null ? new Date(rokVazenja["year"], rokVazenja["month"]-1, rokVazenja["day"]) : null;
            let datum = mainThis.baseFormGroup.get("Datum").value;
            let _datum : Date = datum != null ? new Date(datum["year"], datum["month"]-1, datum["day"]) : null;
            let datumPrometaOd = group.controls[datumPrometaOdKey].value;
            let _datumPrometaOd : Date = datumPrometaOd != null ? new Date(datumPrometaOd["year"], datumPrometaOd["month"]-1, datumPrometaOd["day"]) : null;
            let datumPrometaDo = group.controls[datumPrometaDoKey].value;
            let _datumPrometaDo : Date = datumPrometaDo != null ? new Date(datumPrometaDo["year"], datumPrometaDo["month"]-1, datumPrometaDo["day"]) : null;

            let genericName : string = null;

             if (mainThis.podvrstaDokumentaGn)
                genericName = mainThis.podvrstaDokumentaGn;
           
            if (genericName == "iz_fakt" || genericName == "ko"){
                // if ((_datDpo == null && _datumOtpremnice >= _datum) || (_datDpo >= _datum && _datumOtpremnice == null) || (_datDpo >= _datum && _datumOtpremnice >= _datum)
                //     || (_datDpo >= _datum && _datumPrometaOd == null) || (_datDpo >= _datum && _datumPrometaOd >= _datum)
                //     || (_datDpo >= _datum && _datumPrometaDo == null) || (_datDpo >= _datum && _datumPrometaDo >= _datum))
                //     return null;
              
                if (_datDpo == null && _datumOtpremnice == null && _datumPrometaOd == null && _datumPrometaDo == null)
                    return null;

                if ((_datDpo && _datDpo < _datum) || (_datumOtpremnice && _datumOtpremnice > _datum)){
                    return { 
                            checkControlsDpo : {valid : _datDpo && _datDpo < _datum ? false : true, message : 'FAKDOKUMENT.DATDPO.VALIDATION.DATUMMANJI'},
                            checkControlsOtpr : {valid : _datumOtpremnice && _datumOtpremnice > _datum ? false : true, message : 'FAKDOKUMENT.DATUMOTPREMNICE.VALIDATION.DATUMVECI'}
                        }; 
                } 

                if ((_datumPrometaOd && _datumPrometaOd > _datum) || (_datumPrometaDo && _datumPrometaDo > _datum)){
                    return { 
                            checkControlsDatumPrometaOd : {valid : _datumPrometaOd && _datumPrometaOd > _datum ? false : true, message : 'FAKDOKUMENT.DATUMPROMETAOD.VALIDATION.DATUMVECI'},
                            checkControlsDatumPrometaDo : {valid : _datumPrometaDo && _datumPrometaDo > _datum ? false : true, message : 'FAKDOKUMENT.DATUMPROMETADO.VALIDATION.DATUMVECI'}
                        }; 
                } 

            
            }
            else{
                if (_rokVazenja == null || _rokVazenja >= _datum)
                    return null;
                
                if (_rokVazenja < _datum){
                    return { 
                            checkControlsRokVazenja : {valid : _rokVazenja && _rokVazenja < _datum ? false : true, message : 'FAKDOKUMENT.ROKVAZENJA.VALIDATION.DATUMMANJI'}
                    };
                } 

            }
        }
        
    }

    function checkDatumPrometa(datumOdKey: string, datumDoKey: string) {
        return (group: FormGroup): { [key: string]: any } | null => {
          const datumOd = group.get(datumOdKey).value;
          const datumDo = group.get(datumDoKey).value;
      
          if (datumOd && datumDo) {
            const _datumOd: Date = new Date(
              datumOd.year,
              datumOd.month - 1,
              datumOd.day
            );
            const _datumDo: Date = new Date(
              datumDo.year,
              datumDo.month - 1,
              datumDo.day
            );
      
            if (_datumOd.getTime() > _datumDo.getTime()) {
              return {
                checkControlsDatumDo: {
                  valid: false,
                  message: 'Datum prometa od ne sme biti veći od datuma prometa do!'
                }
              };
            }
          }
      
          return null;
        };
      }
      
    function checkIfCustomerJBKJS(brojUgovoraKey : string, mainThis: any){
        return (group: FormGroup): {[key : string]: any} =>{
            if (group){
                let _brojUgovora = group.parent.get(brojUgovoraKey) as FormControl;
                let brojUgovora : string = _brojUgovora.value;
                let jbkjs : string = mainThis.pamtiVrednostJBKJS;

                // if (jbkjs == null && brojUgovora == null)
                if (
                    (jbkjs == null || jbkjs =="")
                    && (brojUgovora == null || brojUgovora=="")
                )
                    return null;

                if (jbkjs != null && (brojUgovora == null || brojUgovora == ""))
                        return { 
                            // checkControlBrojUgovora : {valid : (brojUgovora == null || brojUgovora == '') ? false : true, message : 'FAKDOKUMENT.BROJUGOVORA.VALIDATION.NIJEUNETAJBKJSKOMITENT'}
                            checkControlBrojUgovora: true
                        };
                else
                    return null;
                    
                }
            } 
        }

    function checkDatumUgovoraInKZ(vrstaDatumaPoreskeObaveze : string, datumUgovora : string, mainThis: any){
        return (group: FormGroup): { [key: string]: any } | null => {
            const _vrstaDatumaPoreskeObaveze : number = group.get(vrstaDatumaPoreskeObaveze).value;
            const _datumUgovora : Date = group.get(datumUgovora).value;
            if (_vrstaDatumaPoreskeObaveze && datumUgovora){
                let genericName : string = null;

                if (mainThis.podvrstaDokumentaGn)
                   genericName = mainThis.podvrstaDokumentaGn;

                if(genericName == "kz" && _vrstaDatumaPoreskeObaveze == 2 && _datumUgovora == null)
                    return {
                        checkDatumUgovora: {
                        valid: false,
                        message: 'Obavezan datum ugovora za odabrani Nastanak PDV obaveze.'
                        }
                      };
            }
            return null;
        }

    }

    function checkPoreskoOslobodjenjeSinh(datumKey: string, poreskoOslobodjenjeIDKey : string, mainThis: any){
        return (control: AbstractControl) => {
            const _datum = control.get(datumKey).value;
            const _poreskoOslobodjenjeID = control.get(poreskoOslobodjenjeIDKey).value;
            const _poreskaOslobodjenjaItems = mainThis.PoreskaOslobodjenjaItems;
            if (!_datum || !_poreskoOslobodjenjeID || !_poreskaOslobodjenjaItems)
                return null;
           
            const foundItem = _poreskaOslobodjenjaItems.find(item => item.ID === _poreskoOslobodjenjeID);
            if (!foundItem)
                return null;


            let _activeFrom : Date = new Date(foundItem["ActiveFrom"]);
            _activeFrom = new Date(_activeFrom.getFullYear(), _activeFrom.getMonth(), _activeFrom.getDate());
            let _activeTo : Date = new Date(foundItem["ActiveTo"]);
            _activeTo = new Date(_activeTo.getFullYear(), _activeTo.getMonth(), _activeTo.getDate());
            let datum : Date = new Date(_datum.year, _datum.month - 1, _datum.day);
            
            if (_activeFrom.getFullYear() > 1901 && _activeTo.getFullYear() == 1901 && !(datum >= _activeFrom))
                return { checkPoreskoOslobodjenje: { valid: false, message: 'Poresko oslobođenje nije dobro.' } };

            if (_activeFrom.getFullYear() == 1901 && _activeTo.getFullYear() > 1901 && !(datum < _activeTo))
                return { checkPoreskoOslobodjenje: { valid: false, message: 'Poresko oslobođenje nije dobro.' } };

            if (_activeFrom.getFullYear() > 1901 && _activeTo.getFullYear() > 1901 && !(datum >= _activeFrom && datum < _activeTo))
                return { checkPoreskoOslobodjenje: { valid: false, message: 'Poresko oslobođenje nije dobro.' } };

        }

    }

    function checkPoreskoOslobodjenje(datum: string, poreskoOslobodjenjeID : string, mainThis: any){
        return (control: AbstractControl) => {
            const _datum = control.get(datum).value;
            const _poreskoOslobodjenjeID = control.get(poreskoOslobodjenjeID).value;
            if (!_datum)
                return of(null);
            else{ 
                if (_poreskoOslobodjenjeID == null)
                    return of(null);

                const parameters = [
                    new QueryParameter('day', _datum.day),
                    new QueryParameter('month', _datum.month),
                    new QueryParameter('year', _datum.year),
                  ];

                
                //  const obs$ = mainThis.baseDataService.Get('PoreskoOslobodjenje', 'GetByDatum', parameters, PoreskoOslobodjenje);
                //  console.log(obs$); 
                
                  // ako imam http poziv ide asyncValidator
                // return mainThis.baseDataService
                // .Get('PoreskoOslobodjenje','GetByDatum', parameters, PoreskoOslobodjenje)
                // .pipe(
                //     retry(3),
                //     tap((items) => console.log('Stigli podaci iz API:', items)), // Proverite vrednost
                //     map((items:any[] | null | undefined)  => {
                //         console.log('Podaci o items iz checkPoreskoOslobodjenje:', items);
                //         console.log('Podaci o parametrima iz checkPoreskoOslobodjenje:', parameters);
                //         if (!items || !Array.isArray(items)) {                           
                //             // return of(null);
                //             return { checkPoreskoOslobodjenje: { valid: false, message: 'Greška: Podaci nisu ispravni.' } };
                //         }
                //         const exists = items.some((item) => item && item.ID === _poreskoOslobodjenjeID);
                //         return exists ? null : { checkPoreskoOslobodjenje: { valid: false, message: 'Poresko oslobođenje nije dobro.' } };
                //      })
                //     ,catchError((error) => {
                //         console.error('Greška pri validaciji:', error);
                //         return of({ checkPoreskoOslobodjenje: { valid: false, message: 'Greška pri validaciji.' } })
                //     })
                        

                // );    
                return of(null).pipe(
                    // delay(2000), // Pauza od 2 sekunde pre izvršavanja poziva
                    switchMap(() => 
                        mainThis.baseDataService.Get('PoreskoOslobodjenje', 'GetByDatum', parameters, PoreskoOslobodjenje)
                    ),
                    map((items: any[] | null | undefined) => {
                        // console.log('Podaci o items iz checkPoreskoOslobodjenje:', items);
                        // console.log('Podaci o parametrima iz checkPoreskoOslobodjenje:', parameters);
                        if (!items || !Array.isArray(items)) {                            
                            return { checkPoreskoOslobodjenje: { valid: false, message: 'Greška: Podaci nisu ispravni.' } };
                        }
                
                        const exists = items.some((item) => item && item.ID === _poreskoOslobodjenjeID);
                        return exists ? null : { checkPoreskoOslobodjenje: { valid: false, message: 'Poresko oslobođenje nije dobro.' } };
                    }),
                    catchError((error) => {
                        console.error('Greška u HTTP zahtevu:', error);
                        return of({ checkPoreskoOslobodjenje: { valid: false, message: 'Greška pri validaciji.' } });
                    })
                );
            }
            
        }

    }

    function checkDatumSmanjenjaKOSinh(datumSmanjenjaKey: string, mainThis: any){
        return (control: AbstractControl) => {
            const _datum = control.get(datumSmanjenjaKey).value;
            if (!_datum )
                return null;
             let genericName : string = null;
            if (mainThis.podvrstaDokumentaGn)
                genericName = mainThis.podvrstaDokumentaGn;

            if(genericName == "ko" && _datum == null)
                return {
                    checkDatumSmanjenja: {
                    valid: false,
                    message: 'FAKDOKUMENT.DATUMSMANJENJA.VALIDATION.REQUIRED'
                    }
                };
            else
                return null;
        }
    }

    
